import React from 'react';
import {
  loSearchColumns,
  QUERY_KEYS,
  vatTuSearchColumns,
  viTriSearchColumns,
  warehouseSearchColumns
} from '@/constants';
import { KhoHang, Lo, VatTu, ViTriKho } from '@/types/schemas';
import { SearchFieldActions, SearchFieldState } from '../../hooks';
import { SearchField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface DetailTabProps {
  formState: {
    state: SearchFieldState;
    actions: SearchFieldActions;
  };
}
const DetailTab = ({ formState: { state, actions } }: DetailTabProps) => {
  return (
    <div className='p-4'>
      <div className='flex items-center'>
        <Label className='w-40'>Mã vật tư</Label>
        <SearchField<VatTu>
          searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
          searchColumns={vatTuSearchColumns}
          columnDisplay='ma_vt'
          displayRelatedField='ten_vt'
          dialogTitle='Danh mục vật tư'
          value={state.vatTu?.ma_vt || ''}
          relatedFieldValue={state.vatTu?.ten_vt || ''}
          onRowSelection={actions.setVatTu}
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40'>Mã kho</Label>
        <SearchField<KhoHang>
          searchEndpoint={`/${QUERY_KEYS.KHO_HANG}/`}
          searchColumns={warehouseSearchColumns}
          columnDisplay='ma_kho'
          displayRelatedField='ten_kho'
          dialogTitle='Danh mục kho hàng'
          value={state.khoHang?.ma_kho || ''}
          relatedFieldValue={state.khoHang?.ten_kho || ''}
          onRowSelection={actions.setKhoHang}
        />
      </div>
      <div className='flex items-center'>
        <Label className='w-40'>Mã vị trí</Label>
        <SearchField<ViTriKho>
          searchEndpoint={`/${QUERY_KEYS.VI_TRI_KHO_HANG}/`}
          searchColumns={viTriSearchColumns}
          columnDisplay='ma_vi_tri'
          displayRelatedField='ten_vi_tri'
          dialogTitle='Danh mục vị trí kho hàng'
          value={state.viTri?.ma_vi_tri || ''}
          relatedFieldValue={state.viTri?.ten_vi_tri || ''}
          onRowSelection={actions.setViTri}
        />
      </div>
      <div className='flex items-center'>
        <Label className='w-40'>Mã lô</Label>
        <SearchField<Lo>
          searchEndpoint={`/${QUERY_KEYS.LO}/`}
          searchColumns={loSearchColumns}
          columnDisplay='ma_lo'
          displayRelatedField='ten_lo'
          dialogTitle='Danh mục lô'
          value={state.lo?.ma_lo || ''}
          relatedFieldValue={state.lo?.ten_lo || ''}
          onRowSelection={actions.setLo}
        />
      </div>
    </div>
  );
};

export default DetailTab;
